/* global axios */
import ApiClient from './ApiClient';

class ContactListsAPI extends ApiClient {
  constructor() {
    super('lists', { accountScoped: true });
  }

  materialize(payload) {
    return axios.post(`${this.url}/materialize`, payload);
  }

  addContacts(listId, payload) {
    return axios.post(`${this.url}/${listId}/contacts/bulk_add`, payload);
  }

  removeContacts(listId, payload) {
    return axios.post(`${this.url}/${listId}/contacts/bulk_remove`, payload);
  }

  moveContacts(listId, payload) {
    return axios.post(`${this.url}/${listId}/contacts/move`, payload);
  }
}

export default new ContactListsAPI();
